export const FEATURED_LOCATIONS = {
  HOMEPAGE: "Homepage",
  SEARCH_RESULTS: "SearchResults",
  HIGHLIGHTED: "Highlighted",
};

export const getFeaturedJobsUsedCount = (featuredJobsUsed) => {
  if (Array.isArray(featuredJobsUsed)) return featuredJobsUsed.length;
  return Number(featuredJobsUsed) || 0;
};

export const getActiveFeaturedJobsCount = (features = {}) =>
  Number(
    features.activeFeaturedJobs ??
      features.activeFeaturedJobsCount ??
      getFeaturedJobsUsedCount(features.activeFeaturedJobIds),
  ) || 0;

export const isJobFeaturedOnHomepage = (job) =>
  Boolean(job?.enableHomePageVisibility ?? job?.isFeatured ?? job?.badge);

export const isJobHighlightedInListing = (job) =>
  Boolean(
    job?.enableHighlightedListing ??
      job?.enableHighlightedJob ??
      job?.isHighlighted ??
      job?.isFeatured,
  );

export const hasFeaturedLocation = (locations, location) =>
  Array.isArray(locations) && locations.includes(location);

export const getFeaturedLocationBenefits = (locations, t) => {
  const benefits = [];

  if (hasFeaturedLocation(locations, FEATURED_LOCATIONS.HOMEPAGE)) {
    benefits.push(t("jobs.featured_homepage"));
  }
  if (hasFeaturedLocation(locations, FEATURED_LOCATIONS.SEARCH_RESULTS)) {
    benefits.push(t("jobs.featured_search"));
  }
  if (hasFeaturedLocation(locations, FEATURED_LOCATIONS.HIGHLIGHTED)) {
    benefits.push(t("jobs.featured_listings"));
  }

  return benefits;
};

export const formatSearchBoostScore = (score) => {
  const value = Number(score) || 1;
  return `x${value}`;
};

export const canEnableFeaturedJob = (creditInfo, isCurrentlyFeatured) => {
  if (!creditInfo?.featuredJobsAvailable) {
    return { allowed: false, reason: "no_featured_pack" };
  }

  if (isCurrentlyFeatured) {
    return { allowed: true };
  }

  const used = getFeaturedJobsUsedCount(creditInfo.featuredJobsUsed);
  const remainingLifetime = creditInfo.maxFeaturedJobs - used;

  if (creditInfo.maxFeaturedJobs > 0 && remainingLifetime <= 0) {
    return { allowed: false, reason: "lifetime_limit" };
  }

  const activeCount = getActiveFeaturedJobsCount(creditInfo);

  if (
    creditInfo.maxActiveFeaturedJobs > 0 &&
    activeCount >= creditInfo.maxActiveFeaturedJobs
  ) {
    return { allowed: false, reason: "active_limit" };
  }

  return { allowed: true };
};

export const getFeaturedLimitMessage = (reason, t, creditInfo = {}) => {
  if (reason === "lifetime_limit") {
    return t("jobs.featured_lifetime_limit", {
      max: creditInfo.maxFeaturedJobs,
    });
  }
  if (reason === "active_limit") {
    return t("jobs.featured_active_limit", {
      max: creditInfo.maxActiveFeaturedJobs,
    });
  }
  return t("jobs.featured_not_available");
};
